import { database } from '@barbanet/database'
import { defineStore } from 'pinia'

import { onMounted, ref } from 'vue'

export const STORAGE_KEY = 'user_permissions'

export const usePermissionStore = defineStore('ui-kit:permission', () => {
	const permissions = ref<string[]>([])

	onMounted(async () => {
		const cachedPermissions = await database.getItem<string[]>(STORAGE_KEY)

		if (cachedPermissions && cachedPermissions.length) {
			permissions.value = cachedPermissions
		}
	})

	const setPermissions = async (value: string[]) => {
		permissions.value = value

		await database.setItem(STORAGE_KEY, value)
	}

	const clearPermissions = async () => {
		permissions.value = []

		await database.removeItem(STORAGE_KEY)
	}

	return {
		permissions,
		setPermissions,
		clearPermissions
	}
})
